<template>
  <base-legal-page
    title="Privacy Policy"
    updated="January 2025"
  >
    <h2>1. Introduction</h2>
    <p>
      Welcome to Hacker Hang ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website hackerhang.com and use our services.
    </p>

    <h2>2. Information We Collect</h2>
    <p>We may collect personal information that you voluntarily provide to us when you:</p>
    <ul>
      <li>Register for an account or session</li>
      <li>Sign in using Facebook or other social media platforms</li>
      <li>Contact us through our website</li>
      <li>Subscribe to our newsletter</li>
      <li>Participate in our sessions or events</li>
    </ul>
    <p>
      This information may include your name, email address, phone number, profile picture, and payment information.
    </p>

    <h2>3. Information from Social Media</h2>
    <p>
      If you choose to register or log in to our services using a social media account (such as Facebook), we may have access to certain information about you from that social media provider, including your name, email address, profile picture, and public profile information, in accordance with the authorization procedures determined by that social media provider.
    </p>

    <h2>4. How We Use Your Information</h2>
    <p>We use the information we collect to:</p>
    <ul>
      <li>Provide, operate, and maintain our services</li>
      <li>Process registrations and payments</li>
      <li>Send you communications about sessions and events</li>
      <li>Respond to your inquiries and support requests</li>
      <li>Improve our website and services</li>
      <li>Comply with legal obligations</li>
    </ul>

    <h2>5. Sharing Your Information</h2>
    <p>
      We do not sell, trade, or rent your personal information to third parties. We may share your information with trusted service providers who assist us in operating our website and conducting our business, as long as they agree to keep this information confidential.
    </p>

    <h2>6. Data Security</h2>
    <p>
      We implement appropriate technical and organizational security measures to protect your personal information. However, no method of transmission over the Internet or electronic storage is 100% secure.
    </p>

    <h2>7. Your Rights</h2>
    <p>You have the right to:</p>
    <ul>
      <li>Access, update, or delete your personal information</li>
      <li>Opt-out of marketing communications</li>
      <li>Request a copy of your data</li>
      <li>Request deletion of your data</li>
    </ul>

    <h2>8. Contact Us</h2>
    <p>If you have questions about this Privacy Policy, please contact us at:</p>
    <div class="hh-legal__contact">
      <div><strong>Email:</strong> <a href="mailto:info@hackerhang.com">info@hackerhang.com</a></div>
      <div><strong>Website:</strong> <a href="https://hackerhang.com">hackerhang.com</a></div>
    </div>
  </base-legal-page>
</template>

<script>
  export default {
    name: 'PrivacyPolicy',

    metaInfo: { title: 'Privacy Policy' },
  }
</script>
